<template>
    <section class="question">
        <question-tag
            :correctRate="question.avgSolveTime"
            :avgSolveTime="question.avgSolveTime"
            :level="paperLevel"
        ></question-tag>

        <!-- {{solveTime}}
        
        {{setedAnswer}} -->
        <div class="pda-default">

            <div class="single" v-if="groupQuestionCount === 1">
                <div class="t-subtitle5">
                    {{ question.contents.text }}
                </div>
                <div class="mgt-16 independent-img-video-bd-radius" v-if="question.contents.image">
                    <img :src="question.contents.image" alt="">
                </div>

                <div class="question-choices mgt-16">
                    <div class="t-body1 choice" v-for="(choice, index) in question.choices" :key="index" :class="{'on': selected[index]}" @click="setSelected(index)">
                        <div class="d-flex align-items-center mgl-8 mgr-8 pdt-5 pdb-5">
                            <div class="number-circle mgl-8 mgr-8">{{index+1}}</div>
                            <div class="mgl-8 mgr-8">
                                {{ choice.contents }}
                            </div>
                        </div>
                        <div class="mgt-11 mgb-10 mgl-16 mgr-16 independent-img-video-bd-radius" v-if="choice.image">
                            <img :src="choice.image" alt="">
                        </div>
                    </div>
                </div> 

            </div>


            <div class="group mgb-30" v-else>
                <div class="bottom-card1">
                    <div class="mdc-card mdc-elevation--z2 bottom-card1-1 bg-documentGray"></div>
                </div>
                <div class="bottom-card2">
                    <div class="mdc-card mdc-elevation--z1 bottom-card2-1 bg-documentGray"></div>
                </div>
                
                <div class="t-subtitle5">
                    {{groupQuestionTitle}}
                </div>

                <div class="mdc-card mdc-elevation--z3 pda-default mgt-16 bg-documentGray">
                    <div class="t-headline14">
                        {{ question.contents.text }}
                    </div>
                    <div class="mgt-16 independent-img-video-bd-radius" v-if="question.contents.image">
                        <img :src="question.contents.image" alt="">
                    </div>

                    <div class="question-choices mgt-16">
                        <div class="t-body1 choice" v-for="(choice, index) in question.choices" :key="index" :class="{'on': selected[index]}" @click="setSelected(index)">
                            <div class="d-flex align-items-center mgl-8 mgr-8 pdt-5 pdb-5">
                                <div class="number-circle mgl-8 mgr-8">{{index+1}}</div>
                                <div class="mgl-8 mgr-8">
                                    {{ choice.contents }}
                                </div>
                            </div>
                            <div class="mgt-11 mgb-10 mgl-16 mgr-16 independent-img-video-bd-radius" v-if="choice.image">
                                <img :src="choice.image" alt="">
                            </div>
                        </div>
                    </div> 
                </div>
            
            </div>

            <div class="h-1"></div>
            
            <question-tip v-if="question.tip" :tip="question.tip"/>
        </div>
        
    </section>


</template>

<script>
/**
 * 다중답안 문항 컴포넌트(choice multiful type question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import QuestionTag from './QuestionTag.vue'
import QuestionTip from './QuestionTip.vue'
import {questionMixin} from '@/mixins/question.js'

export default {
    props: ['question', 'groupQuestionCount', 'groupQuestionTitle', 'currentQuestionCheckStatus', 'setedAnswer', 'paperLevel'],
    data() {
        return {
            selected: [],
            isSolve: false,
        }
    },
    components: {
        'question-tag': QuestionTag,
        'question-tip': QuestionTip,
    },

    mixins: [questionMixin],

    mounted() {
        this.selected = this.setedAnswer.selected
        this.isSolve = this.setedAnswer.isSolve
        this.solveTime = this.setedAnswer.solveTime || 0
        this.startTimer()
        
        
    },

    watch: {
        // currentQuestionCheckStatus에 따라 타이머 동작(currentQuestionCheckStatus timer action)
        currentQuestionCheckStatus: function(value) {
            if (!value) {
                this.startTimer()
            }else {
                this.clearTimer()
            }
        }
    },

    methods: {
        //답안정보 설정 및 부모 컴포넌트에 전달(Answer information setting and delivery to parent component)
        setSelected(selectedIndex) {
            // console.log('selected', this.selected[selectedIndex], selectedIndex);
            //this.selected.$set(selectedIndex, !this.selected[selectedIndex])
            this.selected[selectedIndex] = !this.selected[selectedIndex]
            this.selected.push()

            let answerCount = 0
            for(var i = 0; i < this.selected.length; i++) {
                if (this.selected[i] === true) {
                    answerCount++
                }                
            }
            if (answerCount) {
                this.isSolve = true
            }else {
                this.isSolve = false
            }
            this.setAnswer()
            this.checkIsChecked()
        },

        // 답안설정(Answer setting)
        setAnswer() {
            let params = this.setParam()
            this.$emit('setAnswers', params)
        },

        checkIsChecked() {
            let params = this.setParam()
            this.$emit('checkIsCheckeds',params)
        },

        //답안 초기화(Initialize the answer)
        initAnswer() {
            return _(this.question.choices.length).times(() => {return false})
        },


        // 파라미터 설정(set parameters)
        setParam() {
            let params = {
                questionId: this.question.id,
                text: '',
                selected: this.selected,
                texts: [],
                startDate: this.startDate,
                solveTime: this.solveTime,
                isSolve: this.isSolve
            }

            return params
        },

        
    }
}
</script>